export const clientId = "7f359b56de2137f7f7b00bcb1ab5eb5c";

export const appScopes = "write_content,write_files";
